import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';

// Shared UI Library Components
import { CustomIcon, EIconName } from '@ppmcore/seven-ppm-core-shared-components-react';

// Styles
import './total-info-item.scss';

// Models
import { ITransactionItem } from '../../../../interfaces/transactions.interfaces';
import { TCallType } from '../../../../interfaces/call.interfaces';

export interface ITotalInfoItemProps {
  transaction: ITransactionItem
}

export const TotalInfoItem: FC<ITotalInfoItemProps> = (
  { transaction: { worker, consultation_type, duration, total, created_at } }: ITotalInfoItemProps
) => {

  const getIconName = (type: TCallType): EIconName => {
    if (type === 'video_call') {
      return EIconName.CameraOn;
    }
    if (type === 'audio_call') {
      return EIconName.Call;
    }
    return EIconName.Message;
  }

  return (
    <div className="total-info-item">
      <div className="total-info-item--icon">
        <CustomIcon name={ getIconName(consultation_type) }/>
      </div>
      <div className="total-info-item--info">
        <div className="info-title">
          <Link to={ `/expert/${ worker.id }` }>{ worker.first_name + ' ' + worker.last_name }</Link>
        </div>
        { duration?.text && <div className="info-duration">
          { duration?.text }
        </div> }
      </div>
      <div className="total-info-item--total">
        <div className="total-price">
          { total?.text }
        </div>
        <div className="total-date">
          { dayjs(created_at).format('DD MMM YYYY, hh:mm A') }
        </div>
      </div>
    </div>
  );
};
